import { arrayOf } from 'prop-types';

import GenericStore from '../classes/generic-store';
import { UserSearchesApi } from '../api/user-searches-api';

import { OpportunitiesStore } from './opportunities-store';

class UserOpportunityFiltersStoreClass extends GenericStore {
  load() {
    return this.setState(
      UserSearchesApi.readUserSearches('opportunity')
        .toPromise()
        .then(({ data: userFilters }) => {
          return userFilters.map(item => ({
            id: item.id,
            name: item.name,
            filters: item.search,
          }));
        })
    );
  }

  getType() {
    return 'opportunity';
  }

  getDataShape() {
    return arrayOf(OpportunitiesStore.getMetaConfigShape());
  }
}

export const UserOpportunityFiltersStore =
  new UserOpportunityFiltersStoreClass();
